import { Target, Sparkles } from "lucide-react";


export const goals = [
    {
        value: "Awareness",
        icon: Sparkles,
        desc: "Understand where your money goes",
    },
    {
        value: "Control",
        icon: Target,
        desc: "Take charge of your spending",
    },
    {
        value: "Peace",
        icon: Sparkles,
        desc: "Find financial calm and clarity",
    },
];